import React from "react";
import { Link } from "react-router-dom";
import styles from "./OffersBusiness.module.css";

function CheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={styles.check_icon}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth="2"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );
}

function Starter() {
  return (
    <React.Fragment>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Business Process Analysis</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Process Analysis Report</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>
          "AS IS" Business Process Model
        </h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Business Process Simulation</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Resource Implementation</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Time Consuming Report</h4>
      </li>
    </React.Fragment>
  );
}

function Advanced() {
  return (
    <React.Fragment>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Everything From STARTER</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Regular Monthly Meetings</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>
          "TO BE" Business Process Model
        </h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Cost Consuming Report</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Detailed Activity Report</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Application Cost Calculation</h4>
      </li>
    </React.Fragment>
  );
}
function Premium() {
  return (
    <React.Fragment>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Everything From ADVANCED</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Business Branch Analysis</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Modeling Documentation</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>Simulation Documentation</h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>
          Comparison Between "AS IS" and "TO BE"
        </h4>
      </li>
      <li className={styles.list_item}>
        <CheckIcon></CheckIcon>
        <h4 className={styles.list_item_name}>
          Application for Process Managment
        </h4>
      </li>
    </React.Fragment>
  );
}

function OffersBusiness() {
  return (
    <React.Fragment>
      <div className={styles.offer_wrapper}>
        <h2 className={styles.offer_title}>
          With Us You Pay
          <br />
          Only What You Need
          <br />
          <span className={styles.offer_title_span}>And You Can Lease It</span>
        </h2>
        <Link to="/contact-us" className={styles.offer_link}>
          <div className={styles.offer_link_wrapper}>
            <span className={styles.offer_link_wrapper_first}>
              THIS IS AWESOME
            </span>
            <span className={styles.offer_link_wrapper_second}>
              GIVE ME AN OFFER
            </span>
          </div>
        </Link>
        <article>
          <div className={styles.card}>
            <h3 className={styles.card_title}>STARTER</h3>
            <p className={styles.card_excerpt}>
              For small companies that want to improve their Business Processes
            </p>
            <div className={styles.card_list_wrapper}>
              <ul className={styles.card_list}>
                <Starter></Starter>
              </ul>
            </div>
            <div className={styles.card_price}>
              <span className={styles.starting_at}>STARTING AT</span>
              <span className={styles.price}>
                800€<span className={styles.per_month}>per month</span>
              </span>
            </div>
            <span className={styles.min_month}>(min. 12 months)</span>
          </div>
        </article>
        <article>
          <div className={styles.card}>
            <h3 className={styles.card_title}>ADVANCED</h3>
            <p className={styles.card_excerpt}>
              For those who already have a defined business logic but want to
              become better
            </p>
            <div className={styles.card_list_wrapper}>
              <ul className={styles.card_list}>
                <Advanced></Advanced>
              </ul>
            </div>
            <div className={styles.card_price}>
              <span className={styles.starting_at}>STARTING AT</span>
              <span className={styles.price}>
                3000€<span className={styles.per_month}>per month</span>
              </span>
            </div>
            <span className={styles.min_month}>(min. 12 months)</span>
          </div>
        </article>
        <article>
          <div className={styles.card}>
            <h3 className={styles.card_title}>PREMIUM</h3>
            <p className={styles.card_excerpt}>
              For large scale business with ambition to become leaders in their
              field
            </p>
            <div className={styles.card_list_wrapper}>
              <ul className={styles.card_list}>
                <Premium></Premium>
              </ul>
            </div>
            <div className={styles.card_price}>
              <span className={styles.starting_at}>STARTING AT</span>
              <span className={styles.price}>
                6000€<span className={styles.per_month}>per month</span>
              </span>
            </div>
            <span className={styles.min_month}>(min. 12 months)</span>
          </div>
        </article>
      </div>
    </React.Fragment>
  );
}

export default OffersBusiness;
